interface DataType {
   id: number,
   name: string;
   date: string;
   course: string;
};

const instructor_reviewe_data: DataType[] = [
   {
      id: 1,
      name: "John Due",
      date: "January 30, 2024",
      course: "The Complete Graphic Design",
   },
   {
      id: 2,
      name: "John Due",
      date: "January 30, 2024",
      course: "The Complete Graphic Design",
   },
   {
      id: 3,
      name: "John Due",
      date: "January 30, 2024",
      course: "The Complete Graphic Design",
   },
   {
      id: 4,
      name: "John Due",
      date: "January 30, 2024",
      course: "The Complete Graphic Design",
   },
];

export default instructor_reviewe_data;